module.exports = __webpack_public_path__ + "img/gls.01aee8e3.png";